// src/pages/Faq.jsx
import React, { useState, useEffect } from 'react';

const Faq = () => {
  const [faqData, setFaqData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [expanded, setExpanded] = useState(null);

  useEffect(() => {
    const fetchFaq = async () => {
      const backendURL = process.env.REACT_APP_BACKEND_URL;
      try {
        // Replace with your actual Express endpoint URL for FAQ data.
        const response = await fetch(`${backendURL}faq/faq`);
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        const data = await response.json();
        setFaqData(data);
      } catch (error) {
        console.error("Error fetching FAQ:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchFaq();
  }, []);

  const toggleAccordion = (index) => {
    setExpanded(expanded === index ? null : index);
  };

  if (loading) {
    return (
      <section className="my-24 bg-white dark:bg-gray-900 flex justify-center items-center h-64">
        <div className="animate-spin rounded-full h-16 w-16 border-t-4 border-blue-500"></div>
      </section>
    );
  }

  // Build an array of FAQ items from the fetched data.
  // Adjust field names if necessary.
  const faqItems = faqData
    ? [
        { title: faqData.title1, description: faqData.description1 },
        { title: faqData.title2, description: faqData.description2 },
        { title: faqData.title3, description: faqData.description3 },
        { title: faqData.title4, description: faqData.description4 },
      ]
    : [];

  return (
    <section className="my-24 bg-white dark:bg-gray-900">
      <div className="py-8 px-4 mx-auto max-w-screen-xl sm:py-16 lg:px-6">
        <h2 className="mb-6 lg:mb-8 text-3xl lg:text-4xl tracking-tight font-extrabold text-center text-gray-900 dark:text-white">
          Frequently Asked Questions
        </h2>
        <div className="mx-auto max-w-screen-md">
          <div id="accordion-flush">
            {faqItems.map((item, index) => (
              <div key={index}>
                <h2 id={`accordion-flush-heading-${index}`}>
                  <button
                    type="button"
                    className="flex justify-between items-center py-5 w-full font-medium text-left text-gray-900 bg-white border-b border-gray-200 dark:border-gray-700 dark:bg-gray-900 dark:text-white"
                    onClick={() => toggleAccordion(index)}
                    aria-expanded={expanded === index ? "true" : "false"}
                    aria-controls={`accordion-flush-body-${index}`}
                  >
                    <span>{item.title}</span>
                    <svg
                      className={`w-6 h-6 transition-transform duration-300 ${
                        expanded === index ? "rotate-180" : ""
                      }`}
                      fill="currentColor"
                      viewBox="0 0 20 20"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        fillRule="evenodd"
                        d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                        clipRule="evenodd"
                      ></path>
                    </svg>
                  </button>
                </h2>
                <div
                  id={`accordion-flush-body-${index}`}
                  className={`${expanded === index ? "" : "hidden"}`}
                  aria-labelledby={`accordion-flush-heading-${index}`}
                >
                  <div className="py-5 border-b border-gray-200 dark:border-gray-700">
                    <p className="text-gray-500 dark:text-gray-400">{item.description}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Faq;
